import fetch from 'utils/fetch';

export const mark = interventioId => {
  const url = `/pco-manager/interventions/${interventioId}/comment`;
  return fetch(url, {
    method: 'PUT',
  }).then(res => res.text());
};

export const unmark = interventionId => {
  const url = `/pco-manager/interventions/${interventionId}/comment`;
  return fetch(url, {
    method: 'DELETE',
  }).then(res => res.text());
};



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/comments/api/index.js